<template>
<div>
  <h1>What are you trying to do?</h1>

  <div class="button-container">
    <baseRoundedRadioButton
      class="activity-selector"
      v-for="(option, index) in goalOptions"
      :key="'type-' + option.title"
      :title="option.title"
      :index="index"
      v-model="form.goalSelectionIndex"
      :isChecked="option.value === form.goalSelectionIndex"
      :is-multiple="false"
      :darkBg="false"
      @roundedRadioCheckUncheck="
        ($event) => {
          form.goalSelectionIndex = goalOptions[$event.index].value;
          setMacrosGoalSelectionIndex(goalOptions[$event.index].value);
        }
      "
    />
  </div>
</div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import baseRoundedRadioButton from '../_base-rounded-radio-button';
import { macroCalculatorComputed, macroCalculatorMethods } from '@state/helpers';
import store from '@state/store';

export default {
  props: ['clickedNext', 'currentStep'],
  mixins: [validationMixin],
  components: {
    baseRoundedRadioButton,
  },
  data() {
    return {
      form: {
        goalSelectionIndex: null,
      },
    };
  },
  validations: {
    form: {
      goalSelectionIndex: {
        required,
      },
    },
  },
  watch: {
    $v: {
      handler: function(val) {
        if (!val.$invalid) {
          this.$emit('can-continue', { value: true });
        } else {
          this.$emit('can-continue', { value: false });
        }
      },
      deep: true,
    },
    clickedNext(val) {
      if (val === true) {
        this.$v.form.$touch();
      }
    },
    currentStep() {
      // If form is valid when user navigates back and forth
      // between steps let's allow them to continue
      if (!this.$v.form.$invalid) {
        this.$emit('can-continue', { value: true });
      }
    },
  },
  mounted() {
    if (!this.$v.$invalid) {
      this.$emit('can-continue', { value: true });
    } else {
      this.$emit('can-continue', { value: false });
    }
  },
  computed: {
    ...macroCalculatorComputed,
  },
  methods: {
    ...macroCalculatorMethods,
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.button-container {
  margin-bottom: 6rem;
}
</style>
